import { useAuth } from './use-auth';

export function useUser() {
  const { user, isLoading, login, logout, logoutMutation } = useAuth();

  return {
    user: user ?? undefined,
    isLoading,
    error: null,
    login: async (credentials: { username: string; password: string }) => {
      await login(credentials.username, credentials.password);
    },
    logout: async () => {
      await logout();
    },
  };
}
